import React, { useEffect, useState } from "react";
import { Avatar, Dropdown, Input, Layout, notification, Badge, Spin } from "antd";
import { UserOutlined, PoweroffOutlined, BookOutlined, SearchOutlined, CompassFilled, LoadingOutlined } from "@ant-design/icons";
import { useNavigate } from "react-router-dom";
import { ajaxService, authService, notificationService, vehicleService } from "../services";
import { useDispatch } from "react-redux";
import { clearPermissions } from "../redux/slices/permissionsSlice";
import { useSelector } from "react-redux";
import NotificationDetail from "../components/NotificationDetail";
import { COMPANY_LOGO, ROLES } from "../constants";
import { resetNotificationCount } from "../pages/adminPortal/notification";
import useNotificationCount from "../hooks/useNotificationCount";
import { db } from "../firebase/config";
import { doc, setDoc } from "firebase/firestore";
import { CiBellOn } from "react-icons/ci";
import { setUser } from "../redux/slices/userSlice";

const { Header } = Layout;

const HeaderComponent = () => {

    const dispatch = useDispatch();
    const navigate = useNavigate();
    const user = useSelector(state => state.user.user);
    const role = localStorage.getItem("role")

    const count = useSelector((state) => state.notification.count);

    const [notifications, setNotifications] = useState([])
    const [detailModal, setDetailModal] = useState(false);
    const [selectedNotification, setSelectedNotification] = useState(null)

    const [dropdown, setDropdown] = useState(false)
    const [vehicleInput, setVehicleInput] = useState(null)

    const [avatarLoaded, setAvatarLoaded] = useState(false);

    useNotificationCount(String(user?.id));

    const handleMenuClick = ({ key }) => {
        if (key === "agreement") {
            window.open(`/customers-portal/term-&-condition/${user?.id}`, "_blank");
        }
        if (key === "profile") {
            navigate("/edit-profiles");
        }
        if (key === "logout") {
            handleLogout();
        }
    };

    const handleLogout = () => {
        ajaxService.post("/logout");
        localStorage.clear();
        dispatch(clearPermissions())
        navigate("/login");
    }

    const handleVehicleSearch = async () => {
        const response = await vehicleService.globalSearch({ vin: vehicleInput });
        if (response?.success ?? false) {
            if (role === ROLES.CUSTOMER) {
                navigate(`/vehicle/${response.data.vehicle_id}`)
            } else {
                navigate(`/vehicle/view/${response.data.vehicle_id}`)
            }
        }
    }

    const getNotifications = async () => {
        const response = await notificationService.fetch(1);
        if (response?.success ?? false) {
            // setNotifications(response.data.data)
            setNotifications(response.data?.notifications?.data || [])
        }
    }

    const initialize = async () => {
        const response = await authService.getLoggedInUser();

        if (response?.success ?? false) {
            dispatch(setUser(response.data)); // ✅ global user
            const notiCount = response?.data?.notification_recipients_count
            // Sync with Firestore
            await setDoc(
                doc(db, 'notification_counts', String(response?.data?.id)),
                { notiCount },
                { merge: true }
            );
        }
    }

    useEffect(() => {
        initialize()
    }, [])

    const handleClose = () => {
        setDetailModal(false)
        setNotifications(prev =>
            prev.map(notification =>
                notification.id === selectedNotification.id
                    ? { ...notification, is_read: 1 }
                    : notification
            )
        );
        if (selectedNotification.is_read === 0) {
            resetNotificationCount(String(user.id))
            if (role !== ROLES.ADMIN) {
                const response = notificationService.read(selectedNotification.id);
                if (response?.success) {
                    notification.error({
                        message: "Error reading the notification."
                    })
                }
            }
        }
    }

    const menu = {
        onClick: handleMenuClick,
        items: [
            {
                key: 'name',
                label: (
                    <span style={{ fontWeight: "bold", pointerEvents: "none", color: "black" }}>
                        Hi, {user?.name}
                    </span>
                ),
                disabled: true,
            },
            {
                type: 'divider',
            },
            (role === ROLES.CUSTOMER) &&
            {
                key: 'agreement',
                icon: <BookOutlined />,
                label: 'Agreement',
            },
            {
                key: 'profile',
                icon: <UserOutlined />,
                label: 'Profile'
            },
            {
                key: 'logout',
                icon: <PoweroffOutlined />,
                label: 'Logout'
            },

        ]
    }

    const menu2 = {
        onClick: (info) => {
            const clickedNotif = notifications.find(n => n.id.toString() === info.key);
            setSelectedNotification(clickedNotif);
            setDetailModal(true);
        },
        items: [
            {
                key: "header",
                label: (
                    <div style={{
                        display: "flex",
                        justifyContent: "space-between",
                        alignItems: "center",
                        fontWeight: "bold",
                        color: "black",
                        padding: "4px 12px"
                    }}>
                        <span style={{ fontSize: 14 }}>Notifications</span>
                        <span
                            style={{ color: "#1890ff", cursor: "pointer", fontWeight: "normal", fontSize: "14px" }}
                            onClick={(e) => {
                                setDropdown(false);
                                navigate("/notifications");
                            }}
                        >
                            View All
                        </span>
                    </div>
                ),
                disabled: true,
            },
            {
                type: "divider",
            },
            ...(notifications.length === 0
                ? [
                    {
                        key: "no-data",
                        label: (
                            <div style={{ padding: "8px 12px", textAlign: "center", color: "gray" }}>
                                No notifications
                            </div>
                        ),
                        disabled: true,
                    },
                ]
                : notifications.map((notif) => ({
                    key: notif.id.toString(),
                    label: (
                        <div
                            style={{
                                display: "flex",
                                alignItems: "center",
                                backgroundColor: (role !== ROLES.ADMIN && notif.is_read === 0) ? "#f0f2f5" : "transparent",
                                width: "300px",
                                padding: 5,
                                borderRadius: "4px",
                                overflow: "hidden", // optional: helps avoid scrollbars in case of nested content
                            }}
                        >
                            <CompassFilled style={{ color: "#1890ff", fontSize: 15, paddingRight: 20 }} />
                            <div style={{ flex: 1 }}>
                                <div style={{ fontWeight: "bold" }}>{notif.subject}</div>
                                <div style={{
                                    marginTop: 4,
                                    whiteSpace: 'nowrap',
                                    overflow: 'hidden',
                                    textOverflow: 'ellipsis',
                                    maxWidth: '100%'
                                }}>{notif.message}</div>
                            </div>
                        </div>
                    ),
                }))),
        ],
        style: {
            maxHeight: "300px",
            minWidth: "300px",
            overflowY: "auto",
        },
    };

    useEffect(() => {
        getNotifications();
    }, [count])


    useEffect(() => {
        if (!user?.profile_image) {
            setAvatarLoaded(true); // no image → show dropdown immediately
            return;
        }

        setAvatarLoaded(false);

        const img = new Image();
        img.src = user.profile_image;

        img.onload = () => setAvatarLoaded(true);
        img.onerror = () => setAvatarLoaded(true); // fallback if broken
    }, [user?.profile_image]);


    return (
        <Header style={{ background: "#FFFFFF" }} className="w-full h-20" >
            <div className="flex justify-between items-center  max-w-7xl mx-auto mt-3">
                <img src={COMPANY_LOGO} alt="Logo" style={{ height: "50px" }} />
                <Input
                    prefix={<SearchOutlined style={{ color: "gray" }} />}
                    value={vehicleInput}
                    placeholder="Search vehicle"
                    onChange={(e) => setVehicleInput(e.target.value)}
                    onPressEnter={handleVehicleSearch}
                    style={{
                        width: 600,
                        border: " none",
                        height: 40,
                        borderTopLeftRadius: 8,
                        borderBottomLeftRadius: 8,
                        backgroundColor: "#F5F5F5"
                    }}
                />

                <div className="flex justify-center items-center gap-4 ">
                    <Dropdown
                        menu={menu2}
                        trigger={['click']}
                        open={dropdown}
                        onOpenChange={(flag) => setDropdown(flag)}
                    >
                        <Badge count={count} style={{ top: 30 }}>
                            <CiBellOn
                                style={{ fontSize: "25px", color: "black", cursor: "pointer" }}
                            // onClick={() => navigate('/notifications')}
                            />
                        </Badge>
                    </Dropdown>

                    {/* <IoSettingsSharp style={{ fontSize: "15px", color: "black" }} /> */}
                    {!avatarLoaded ? (
                        <Spin indicator={<LoadingOutlined style={{ fontSize: 25 }} spin />} />
                    ) : (
                        <Dropdown menu={menu} trigger={["click"]} overlayStyle={{ width: 150 }}>
                            <Avatar
                                size="large"
                                src={user?.profile_image || null}
                                icon={<UserOutlined />}
                                style={{ cursor: "pointer" }}
                            />
                        </Dropdown>
                    )}

                </div>
            </div>
            <NotificationDetail
                detailModal={detailModal}
                selectedNotification={selectedNotification}
                handleClose={handleClose}
            />
        </Header>
    );
};

export default HeaderComponent;
